import BaseComponent from '@components/base-component';
import tag from '@components/utility-components';
import * as styles from './message.module.scss';
const MESSAGES = {
    noValidOptions: 'Please add at least 2 valid options. An option is considered valid if its title is not empty and its weight is greater than 0.',
    invalidFile: 'The file you are trying to upload is invalid. Use the files generated by this application and do not modify their contents.',
    invalidDurationInput: "You have entered an invalid 'Duration' value. The minimum value is 5, the maximum is 100.",
};
export default class Message extends BaseComponent {
    constructor(modalControls, message) {
        super({ elementTag: 'div', classes: [styles.message] });
        const closeButton = tag.button({
            text: 'OK',
            classes: [styles.confirmBtn, 'button'],
            onclick: modalControls.closeModal,
        });
        const text = tag.div({
            classes: [styles.text],
            text: MESSAGES[message],
        });
        this.appendChildren(text, closeButton);
    }
}
